import React,{ useEffect, useState } from 'react';
import { } from 'react-weui';
import { dirPlayEnd } from '@/services/course';
import styles from './styles.scss';
import { history } from 'umi';

import { Tabs } from 'antd-mobile';
import TabDetail from './components/TabDetail';
import TabComment from './components/TabComment';



export default (props) => {
  const {course} = props;

  const [tabs,setTabs] = useState([
    { title: '详情' },
    { title: '评论' },
  ]);
  const [page, setPage] = useState(0);

  return(
    <div className={styles.box}>

      <div className={styles.headerBox}>
        <img className={styles.cover} src={course.image} alt=''/>
      </div>


      <Tabs
        tabs={tabs}
        page={page}
        tabBarActiveTextColor={'#333333'}
        tabBarInactiveTextColor={'#888888'}
        tabBarUnderlineStyle={{backgroundColor:'transparent',height:'2'}}
        onChange={(tab, index) => { setPage(index) }}
        onTabClick={(tab, index) => { setPage(index) }}
      >
        <TabDetail course={course} goComment={() =>{
          setPage(1);
        }}/>

        <TabComment course={course} getCommentCount={(count) => {
          setTabs([
            { title: '详情' },
            { title: '评论' + (count > 0 ? '('+ count+')' : '') },
          ])
        }}/>

      </Tabs>


    </div>
  )
}


